export const ACTION_ENUM ={
    EV001 : 1,
    EV002 : 97,
    EV003 : 3,
    EV004 : 11,
    EV005 : 5,
    EV006 : 12,
    EV007 : [7,8,9,10],
    EV008 : 6,
    EV009 : 100,
    EV010 : 99,
    EV011 : 98,
    EV012 : 4,
    EV013 : 2,
}